"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = void 0;
var core_1 = require("@material-ui/core");
var react_1 = __importDefault(require("react"));
var useStyles = (0, core_1.makeStyles)(function () {
    return (0, core_1.createStyles)({
        root: {
            overflowX: 'auto',
            paddingLeft: 36,
            display: 'flex',
            height: 130,
            flexFlow: 'row nowrap',
            borderBottom: '1px solid #d0d0d0',
            flex: '0 0 auto',
            justifyContent: 'space-between',
            alignItems: 'center',
            backgroundColor: function (_a) {
                var color = _a.color;
                return color;
            }
        }
    });
});
var Header = function (_a) {
    var color = _a.color, children = _a.children;
    var classes = useStyles({ color: color });
    return react_1.default.createElement("header", { "aria-label": 'Page Header', className: classes.root }, children);
};
exports.Header = Header;
//# sourceMappingURL=Header.js.map